<div class="">
    <ng-container *ngIf="!data.action.check_out">
        <div class="font-medium text-primary">Check-in realizado com sucesso!</div>
        <div class="">{{data.action.check_in | date: 'd/MM/Y HH:mm:ss'}}</div>
    </ng-container>

    <ng-container *ngIf="data.action.check_out">
        <div class="font-medium text-primary">Check-out realizado com sucesso!</div>
        <div class="">{{data.action.check_out | date: 'd/MM/Y HH:mm:ss'}}</div>
    </ng-container>

    <div class="w-full flex items-center justify-center mt-8">
        <div class="w-30 h-30 flex items-center justify-center rounded-full bg-primary">
            <mat-icon class="text-white icon-size-16" [svgIcon]="'awesome_solid:check'"></mat-icon>
        </div>
    </div>

    <div class="w-full flex justify-center mt-8">
        <button mat-flat-button mat-dialog-close="" class="min-w-26" [color]="'primary'">Ok</button>
    </div>
</div>
